<template>
  <div>
    <v-autocomplete
      ref="autocompleteRef"
      v-model="select"
      :items="items"
      :loading="isLoading"
      :disabled="isLoading && queryIdUser > 0 || linkedExemptPlayer.alreadyLinked"
      :search-input.sync="search"
      @change="setPlayerId"
      @paste="onPaste"
      :label="$t('searchPlayers')"
      item-text="ui"
      item-value="id"
      prepend-icon="mdi-account-circle"
      dense
      filled
      solo-inverted
      clearable
      hide-details
      return-object
      :no-data-text="$t('autoCompleteNoData')"
      :filter="filter"
      :autofocus="autofocus"
      @click:clear="clearable()"
      :rules="rules"
    >
      <template v-slot:item="data">
        {{ data.item.name }}
        <v-icon
          x-small
          color="primary"
          class="mx-2"
          v-if="data.item.icon == '1'"
        >
          mdi-check-decagram
        </v-icon>
        ({{
          isLinkExemptPlayerAffiliatesView ?
            data.item.id :
            data.item.login
        }})
      </template>
    </v-autocomplete>
    <span
      v-if="
        isLinkExemptPlayerAffiliatesView && !linkedExemptPlayer.alreadyLinked
      "
      class="caption ml-10"
    >
      {{ $t("seachPlayersMsg") }}.
    </span>
  </div>
</template>
<script>
export default {
  name: "components-common-filter-autocomplete-players",
  props: ["rules", "clearAutocomplete"],
  data: () => ({
    select: null,
    isLoading: false,
    items: [],
    search: null,
    term: "",
    _timerId: 0,
    autofocus: false,
    sigla: "",
    previousRoute: "",
    isLinkExemptPlayerAffiliatesView: false,
  }),
  computed: {
    queryIdUser() {
      return this.$route.query.id_user;
    },
    refresh() {
      return this.$store.getters.getRefresh;
    },
    linkedExemptPlayer() {
      return this.$store.state.filters.linkedExemptPlayer;
    },
  },
  mounted() {
    // Aplicando autofocus no filtro somente quando estiver nessas rotas
    if (this.$route.name === "AdministratorUsersPlayersSearch") {
      this.autofocus = true;
    }
    if (
      this.$route.name ===
      "AdministratorAccountabilityOnlinePlayersOnlineSearch"
    ) {
      this.autofocus = true;
    }
    if (
      this.$route.name === "CollaboratorAccountabilityOnlinePlayersOnlineSearch"
    ) {
      this.autofocus = true;
    }

    if (this.queryIdUser > 0) {
      this.autofocus = true;
      //   this.search = this.queryIdUser.substring(0, 3).toString();
      this.search = this.queryIdUser.toString();
    }

    this.isLinkExemptPlayerAffiliatesView =
      this.$route.name == "AdministratorOnlineAffiliatesUsersLinkExemptPlayerAffiliates" ||
      this.$route.name == "AdministratorOnlineAffiliatesUsersLinkAffiliateExemptPlayer" ||
      this.$route.name == "CollaboratorAffiliatesUsersLinkExemptPlayerAffiliates" ||
      this.$route.name == "CollaboratorAffiliatesUsersLinkAffiliateExemptPlayer";

    // Se o afiliado já tiver jogador isento vinculado, o jogador será adicionado
    // como selecionado
    if (this.linkedExemptPlayer.alreadyLinked) {
      const { id, name } = this.linkedExemptPlayer;
      const player = {
        ui: `${name} (${id})`,
        name,
        id,
      };

      this.items.push(player);
      this.select = player;
    }
  },
  watch: {
    clearAutocomplete(bool) {
      if (bool) {
        this.$store.commit("setPlayerId", "");
        this.clearable();
      }
    },
    queryIdUser(val) {
      this.autofocus = true;
      // this.search = val.substring(0, 3).toString();
      this.search = val.toString();
    },
    search(val) {
      if (!val || !val && this.queryIdUser) {
        return;
      }

      this.onSearchChange(val);
    },
    // Se a rota for AdministratorCreditHistoric
    // é importante resetar o filtro para não dar conflito
    // nessa página.
    $route(route) {
      if (
        route.name == "AdministratorUsersPlayersSearch" ||
        route.name == "AdministratorOnlineAffiliatesUsersLinkExemptPlayerAffiliates" ||
        route.name == "CollaboratorAffiliatesUsersLinkExemptPlayerAffiliates"
      ) {
        this.$store.commit("setPlayerId", "");
        this.items = [];
      }

      if (route.name === "AdministratorCreditHistoric") {
        this.$store.commit("setPlayerId", "");
      }
    },
  },
  methods: {
    fetchPlayersDebounced() {
      clearTimeout(this._timerId);

      this._timerId = setTimeout(() => {
        this.getPlayersList();
      }, 500);
    },
    clearable() {
      this.$store.commit("setPlayerId", "");
      this.$store.commit("setLinkedExemptPlayer", {
        alreadyLinked: false,
        id: "",
        name: "",
      });
      this.items = [];
    },
    setPlayerId(player) {
      if (!player) return;

      this.$store.commit("setPlayerId", player.id ? player.id : "");
      this.$store.commit("setLinkedExemptPlayer", {
        alreadyLinked: false,
        id: player.id,
        name: player.name,
      });
    },
    async getPlayersList() {
      this.isLoading = true;
      try {
        const user_data = JSON.parse(localStorage.getItem("user_data"));

        const endpoint = user_data.isCollaborator
          ? "colab/players/search"
          : "administrator/players/search";

        let online = 0;
        let exempt = 0;

        if (
          this.$route.name ==
            "AdministratorAccountabilityOnlinePlayersOnlineSearch" ||
          this.$route.name ==
            "CollaboratorAccountabilityOnlinePlayersOnlineSearch"
        ) {
          online = 1;
        }
        if (this.isLinkExemptPlayerAffiliatesView) {
          exempt = 1;
        }

        const response = await this.$request.post(endpoint, {
          term: this.term.trim(),
          online,
          exempt
        });

        if (response.length == 0) {
          this.items = [];
          return;
        }
        this.items = response.dados.map((item) => ({
          ui: this.isLinkExemptPlayerAffiliatesView ?
            `${item.nome} (${item.id})` :
            `${item.nome} (${item.login} ${item.id})`,
          name: item.nome,
          icon: item.online,
          login: item.login,
          id: item.id,
          // Esse tratamento 'not registered' é só pra devolver 'alguma coisa'
          // para o componente, pois se algumas dessas infos não estiver registrada
          // ele não renderiza corretamente o usuário encontrado, mesmo que a busca seja feita
          // por outra propriedade, por ex.: buscar o usuário pelo login.
          // O tratamento real dessas infos é feito nas views onde o autocomplete é chamado
          cpf: item.cpf ? item.cpf : "not registered",
          celular: item.celular ? item.celular : "not registered",
          email: item.email ? item.email : "not registered",
        }));

        if (this.queryIdUser > 0) {
          this.select = this.items.find((item) => item.id == this.queryIdUser);
          this.$store.commit("setPlayerId", this.queryIdUser);

          if (this.search !== this.queryIdUser) {
            this.$store.commit("setRefresh", true);
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    filter(item, queryText) {
      let fields = ["id", "name", "login", "celular", "email", "cpf", "ui"];

      for (let field of fields) {
        if (
          this.removeAccents(item[field].toLocaleLowerCase()).includes(
            this.removeAccents(queryText.toLocaleLowerCase().trim())
          )
        ) {
          return item;
        }
      }
    },
    onSearchChange(text) {
      let val = text;
      let currentRoute = this.$route.name;
      // Caso o usuário selecionar um usuário da lista
      // não permitir realizar o get novamente.
      // O regex abaixo identifica os caracteres "(" e ")"
      // Contido na string e encerra dando return.
      if (/\(|\)/.test(val)) return;
      //   if (val == null || val.length <= 0) {
      //     this.items = [];
      //     this.sigla = "";
      //   }
      if (!val) {
        this.items = [];
        this.sigla = "";
        this.term = "";
        return;
      }
      if (this.isLoading) return;
      //   if (val.length != 3) {
      //     val = val.substring(0, 3);
      //     if (val.length != 3) {
      //       return;
      //     }
      //   }
      if (val == this.sigla) {
        if (currentRoute == this.previousRoute) {
          return;
        }
      }
      const trimmedVal = val.trim();
      this.sigla = trimmedVal;
      // Request
      if (trimmedVal.length >= 5) {
        if (trimmedVal != this.term || currentRoute != this.previousRoute) {
          this.term = trimmedVal;
          this.fetchPlayersDebounced();
          this.previousRoute = this.$route.name;
        }
      }
    },
    onPaste(evt) {
      const text = evt.clipboardData.getData("text");
      if (text && text.trim().length >= 5) {
        this.select = text;
        this.onSearchChange(text);
      }
    },
    removeAccents(str) {
      let string = str;

      const mapAccentsHexCode = {
        a: /[\xE0-\xE6]/g,
        A: /[\xC0-\xC6]/g,
        e: /[\xE8-\xEB]/g,
        E: /[\xC8-\xCB]/g,
        i: /[\xEC-\xEF]/g,
        I: /[\xCC-\xCF]/g,
        o: /[\xF2-\xF6]/g,
        O: /[\xD2-\xD6]/g,
        u: /[\xF9-\xFC]/g,
        U: /[\xD9-\xDC]/g,
        c: /\xE7/g,
        C: /\xC7/g,
        n: /\xF1/g,
        N: /\xD1/g,
      };

      for (let letter in mapAccentsHexCode) {
        let regex = mapAccentsHexCode[letter];
        string = string.replace(regex, letter);
      }

      return string;
    },
  },
};
</script>
